/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetPossiblePrefixes$Params {
  organisation_id: string;
  prefix: string;
  prefix_length: number;
  subzone_prefix_length: number;
}

export function getPossiblePrefixes(
  http: HttpClient,
  rootUrl: string,
  params: GetPossiblePrefixes$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getPossiblePrefixes.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("prefix", params.prefix, {});
    rb.path("prefix_length", params.prefix_length, {});
    rb.path("subzone_prefix_length", params.subzone_prefix_length, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    }),
  );
}

getPossiblePrefixes.PATH =
  "/surfdomeinen/organisations/{organisation_id}/reverse/subzones/{prefix}/{prefix_length}/{subzone_prefix_length}";
